/* OttiOtti: small independent Shopify storefront interactions. No external apps. */
(() => {
  'use strict';
  const lang = (document.documentElement.lang || 'ro').split('-')[0];
  const tr = ({
    ro: ['Adăugat la favorite ♡','Eliminat din favorite','Varianta nu este disponibilă','Produsul nu a putut fi adăugat.'],
    ru: ['Добавлено в избранное ♡','Удалено из избранного','Вариант недоступен','Не удалось добавить товар.'],
    en: ['Saved to favorites ♡','Removed from favorites','Option unavailable','Could not add this product.']
  })[lang] || ['Saved ♡','Removed','Unavailable','Could not add this product.'];
  const key = 'ottiotti:wishlist:v1';
  const favDialog = document.getElementById('OttiFavoritesDialog');
  const quickDialog = document.getElementById('OttiQuickDialog');
  const form = document.getElementById('OttiQuickForm');
  let favorites = [], activeProduct = null, chosenVariant = null;
  try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); favorites = Array.isArray(saved) ? saved.filter(i => i && i.id && i.url).slice(0,150) : []; } catch (_) {}
  const all = selector => Array.from(document.querySelectorAll(selector));
  const safePath = path => {
    try { const u = new URL(path,location.origin); return u.origin === location.origin && /\/products\//.test(u.pathname) ? u.pathname + u.search : ''; }
    catch (_) { return ''; }
  };
  const shopRoot = (window.Shopify?.routes?.root) || '/';
  function toast(message) {
    document.querySelector('.otti-shop-toast')?.remove();
    const el = document.createElement('div'); el.className = 'otti-shop-toast'; el.setAttribute('role','status'); el.textContent = message;
    document.body.appendChild(el); setTimeout(() => el.remove(), 3000);
  }
  function writeFavorites() {
    try { localStorage.setItem(key,JSON.stringify(favorites)); } catch (_) {}
    repaintFavorites();
  }
  function repaintFavorites() {
    const ids = new Set(favorites.map(i => String(i.id)));
    all('[data-otti-favorite]').forEach(btn => btn.setAttribute('aria-pressed',String(ids.has(String(btn.dataset.id)))));
    all('[data-otti-favorite-count]').forEach(el => { el.textContent = String(favorites.length); el.hidden = !favorites.length; });
    all('[data-otti-fav-dialog-count]').forEach(el => { el.textContent = String(favorites.length); });
    if (!favDialog) return;
    const wrap = favDialog.querySelector('[data-otti-fav-items]'); const empty = favDialog.querySelector('[data-otti-fav-empty]');
    if (!wrap) return;
    wrap.replaceChildren(); if (empty) empty.hidden = favorites.length > 0;
    favorites.forEach(item => {
      const href = safePath(item.url); if (!href) return;
      const row = document.createElement('div'); row.className = 'otti-wishlist-item';
      const imageLink = document.createElement('a'); imageLink.href = href;
      const image = document.createElement('img'); image.alt = item.name || ''; image.loading = 'lazy';
      if (item.image) {
        try { const src = new URL(item.image,location.origin); if (/^https?:$/.test(src.protocol)) image.src = src.href; } catch (_) {}
      }
      imageLink.appendChild(image);
      const details = document.createElement('div'); const title = document.createElement('a'); title.href = href; title.textContent = item.name || '';
      const price = document.createElement('strong'); price.textContent = item.price || ''; details.append(title,price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label',tr[1]);
      remove.addEventListener('click',() => { favorites = favorites.filter(i => String(i.id) !== String(item.id)); writeFavorites(); });
      row.append(imageLink,details,remove); wrap.appendChild(row);
    });
  }
  function toggleFavorite(btn) {
    const id = String(btn.dataset.id || ''); const href = safePath(btn.dataset.href || ''); if (!id || !href) return;
    const found = favorites.findIndex(i => String(i.id) === id);
    if (found >= 0) { favorites.splice(found,1); toast(tr[1]); }
    else { favorites.unshift({id,url:href,name:btn.dataset.title || '',price:btn.dataset.price || '',image:btn.dataset.image || ''}); toast(tr[0]); }
    writeFavorites();
  }
  [favDialog,quickDialog].forEach(dialog => {
    if (!dialog) return;
    dialog.querySelectorAll('[data-otti-close]').forEach(btn => btn.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click',event => { if (event.target === dialog) dialog.close(); });
  });
  const money = cents => {
    const cur = document.documentElement.dataset.ottiCurrency || 'MDL';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'ro-MD', {style:'currency',currency:cur}).format((Number(cents)||0)/100); }
    catch (_) { return `${((Number(cents)||0)/100).toFixed(2)} ${cur}`; }
  };
  let galleryImages = [];
  let galleryIndex = 0;
  const galleryTrack = quickDialog?.querySelector('[data-otti-modal-gallery]');
  const galleryCount = quickDialog?.querySelector('[data-otti-modal-gallery-count]');
  const galleryControls = quickDialog?.querySelector('[data-otti-modal-gallery-controls]');
  const galleryHint = quickDialog?.querySelector('[data-otti-modal-gallery-hint]');
  const galleryNormalize = value => {
    const raw = typeof value === 'string' ? value : (value?.src || value?.url || '');
    if (!raw) return '';
    try {
      const url = new URL(raw,location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      return url.href;
    } catch (_) { return ''; }
  };
  const galleryIdentity = value => {
    try { const u = new URL(value,location.origin); return u.hostname.toLowerCase() + u.pathname.replace(/_\d+x\d+(?=\.)/g,''); }
    catch (_) { return value; }
  };
  const galleryText = ({
    ro: {previous:'Imaginea precedentă',next:'Imaginea următoare',hint:'Glisează pentru mai multe imagini'},
    ru: {previous:'Предыдущее фото',next:'Следующее фото',hint:'Листайте фотографии'},
    en: {previous:'Previous photo',next:'Next photo',hint:'Swipe for more photos'}
  })[lang] || {previous:'Previous photo',next:'Next photo',hint:'Swipe for more photos'};
  function slideTo(index, smooth=true) {
    if (!galleryTrack || !galleryImages.length) return;
    galleryIndex = Math.max(0,Math.min(galleryImages.length-1,index));
    galleryTrack.scrollTo({left:galleryTrack.clientWidth*galleryIndex,behavior:smooth?'smooth':'instant'});
    updateGalleryControls();
  }
  function updateGalleryControls() {
    if (!galleryCount) return;
    galleryCount.textContent = galleryImages.length ? `${galleryIndex+1} / ${galleryImages.length}` : '';
    if (galleryControls) galleryControls.hidden = galleryImages.length <= 1;
    if (galleryHint) galleryHint.hidden = galleryImages.length <= 1;
    quickDialog?.querySelector('[data-otti-gallery-prev]')?.toggleAttribute('disabled',galleryIndex === 0);
    quickDialog?.querySelector('[data-otti-gallery-next]')?.toggleAttribute('disabled',galleryIndex >= galleryImages.length-1);
  }
  function renderGallery(product, fallback='') {
    if (!galleryTrack) return;
    const sources = [];
    if (product) {
      if (Array.isArray(product.images)) sources.push(...product.images);
      if (product.featured_image) sources.unshift(product.featured_image);
      (product.variants || []).forEach(v => { if (v.featured_image) sources.push(v.featured_image); });
    } else if (fallback) sources.push(fallback);
    if (!sources.length && fallback) sources.push(fallback);
    const seen = new Set(); galleryImages = [];
    sources.forEach(source => {
      const url = galleryNormalize(source); const id = galleryIdentity(url);
      if (url && !seen.has(id)) { seen.add(id); galleryImages.push(url); }
    });
    galleryTrack.replaceChildren(); galleryIndex = 0;
    galleryImages.forEach((src,index) => {
      const slide = document.createElement('div');slide.className='otti-quick-dialog__slide';
      const img = document.createElement('img');img.className='otti-quick-dialog__image';
      img.src=src; img.alt=(product?.title || quickDialog.querySelector('[data-otti-modal-title]')?.textContent || '') + (galleryImages.length>1? ` — ${index+1}` : '');
      img.loading=index===0?'eager':'lazy';img.decoding='async';
      slide.appendChild(img);galleryTrack.appendChild(slide);
    });
    galleryTrack.scrollLeft=0;
    if (galleryHint) galleryHint.textContent=galleryText.hint;
    updateGalleryControls();
  }
  function focusVariantImage(variant) {
    const src = galleryNormalize(variant?.featured_image);
    if (!src || !galleryImages.length) return;
    const id = galleryIdentity(src);
    const index = galleryImages.findIndex(image => galleryIdentity(image) === id);
    if (index >= 0 && index !== galleryIndex) slideTo(index);
  }
  galleryTrack?.addEventListener('scroll',() => {
    if (!galleryTrack.clientWidth) return;
    const index=Math.max(0,Math.min(galleryImages.length-1,Math.round(galleryTrack.scrollLeft/galleryTrack.clientWidth)));
    if (index !== galleryIndex){galleryIndex=index;updateGalleryControls();}
  },{passive:true});
  quickDialog?.querySelector('[data-otti-gallery-prev]')?.addEventListener('click',() => slideTo(galleryIndex-1));
  quickDialog?.querySelector('[data-otti-gallery-next]')?.addEventListener('click',() => slideTo(galleryIndex+1));

// Tap a gallery image to view it fully, without any zoom/crop;
// image swipe in the quick view and variant-linked photos still work.
const photoViewer = document.getElementById('OttiPhotoViewer');
const photoViewerImage = photoViewer?.querySelector('[data-otti-photo-full]');
function updatePhotoViewer() {
  if (!photoViewerImage || !galleryImages.length) return;
  photoViewerImage.src = galleryImages[galleryIndex];
  photoViewerImage.alt = quickDialog?.querySelector('[data-otti-modal-title]')?.textContent || '';
  const count = photoViewer.querySelector('[data-otti-photo-count]');
  if (count) count.textContent = `${galleryIndex + 1} / ${galleryImages.length}`;
  photoViewer.querySelector('[data-otti-photo-prev]')?.toggleAttribute('disabled',galleryIndex===0);
  photoViewer.querySelector('[data-otti-photo-next]')?.toggleAttribute('disabled',galleryIndex>=galleryImages.length-1);
}
function movePhotoViewer(delta) {
  slideTo(galleryIndex + delta, false);
  updatePhotoViewer();
}
galleryTrack?.addEventListener('click',event => {
  if (!event.target.closest('img.otti-quick-dialog__image') || !photoViewer || !galleryImages.length) return;
  updatePhotoViewer();
  if (!photoViewer.open) photoViewer.showModal();
});
photoViewer?.querySelector('[data-otti-photo-close]')?.addEventListener('click',() => photoViewer.close());
photoViewer?.querySelector('[data-otti-photo-prev]')?.addEventListener('click',() => movePhotoViewer(-1));
photoViewer?.querySelector('[data-otti-photo-next]')?.addEventListener('click',() => movePhotoViewer(1));
photoViewer?.addEventListener('click',event => {if (event.target === photoViewer) photoViewer.close();});
// Swipe full-screen photography as well (buttons remain keyboard-accessible).
let photoTouchStart = null;
photoViewer?.querySelector('[data-otti-photo-stage]')?.addEventListener('touchstart',event => {
  if (event.touches.length===1) photoTouchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
},{passive:true});
photoViewer?.querySelector('[data-otti-photo-stage]')?.addEventListener('touchend',event => {
  if (!photoTouchStart || !event.changedTouches.length) return;
  const dx=event.changedTouches[0].clientX-photoTouchStart.x;
  const dy=event.changedTouches[0].clientY-photoTouchStart.y;
  if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.2) movePhotoViewer(dx<0?1:-1);
  photoTouchStart=null;
},{passive:true});
quickDialog?.addEventListener('close',() => {if (photoViewer?.open) photoViewer.close();});
  let selectedOptions = [];
  let quickRequestId = 0;
  const optionWords = ({
    ro: { size:'Mărime', color:'Culoare', sold:'Indisponibil', tip:'Opțiunile tăiate nu sunt disponibile', productSold:'Produsul este momentan indisponibil' },
    ru: { size:'Размер', color:'Цвет', sold:'Нет в наличии', tip:'Зачёркнутые варианты недоступны', productSold:'Товар временно недоступен' },
    en: { size:'Size', color:'Color', sold:'Sold out', tip:'Crossed-out options are unavailable', productSold:'Currently sold out' }
  })[lang] || { size:'Size', color:'Color', sold:'Sold out', tip:'Crossed-out options are unavailable', productSold:'Currently sold out' };
  function optionNameForDisplay(name) {
    const cleaned = String(name || '').trim();
    if (/^(?:size|mărime|marime|размер)$/i.test(cleaned)) return optionWords.size;
    if (/^(?:color|colour|culoare|цвет)$/i.test(cleaned)) return optionWords.color;
    return cleaned || (lang === 'ro' ? 'Opțiune' : lang === 'ru' ? 'Вариант' : 'Option');
  }
  const inStockVariants = () => (activeProduct?.variants || []).filter(v => v.available === true);
  function candidatesFor(index, value) {
    return inStockVariants().filter(v =>
      (v.options || [])[index] === value &&
      selectedOptions.slice(0,index).every((selected,i) => (v.options || [])[i] === selected)
    );
  }
  function chooseOption(index, value) {
    const candidates = candidatesFor(index,value);
    if (!candidates.length) return;
    // When changing a color, keep the size if it is in stock. Otherwise
    // select the closest available combination automatically.
    const nearest = candidates.reduce((best,v) => {
      const similarity = v.options.reduce((n,option,i) => n + (i !== index && option === selectedOptions[i] ? 1 : 0),0);
      if (!best || similarity > best.score) return { variant:v, score:similarity };
      return best;
    },null);
    selectedOptions = [...(nearest?.variant.options || [])];
    updateVariant();
  }
  function updateVariant() {
    if (!activeProduct || !quickDialog) return;
    const variants = activeProduct.variants || [];
    chosenVariant = variants.find(v =>
      (v.options || []).length === selectedOptions.length &&
      (v.options || []).every((value,index) => value === selectedOptions[index])
    );
    if (!(activeProduct.options || []).length) chosenVariant = variants[0];
    const ok = !!chosenVariant?.available;
    const submit = quickDialog.querySelector('[data-otti-modal-submit]');
    submit.disabled = !ok;
    quickDialog.querySelector('[data-otti-modal-status]').textContent = ok ? '' : (inStockVariants().length ? tr[2] : optionWords.productSold);
    focusVariantImage(chosenVariant);
    const price = chosenVariant?.price ?? activeProduct.price ?? 0;
    quickDialog.querySelector('[data-otti-modal-price]').textContent = money(price);
    const compare = quickDialog.querySelector('[data-otti-modal-compare]');
    const oldPrice = Number(chosenVariant && 'compare_at_price' in chosenVariant ? chosenVariant.compare_at_price : (activeProduct.compare_at_price || 0));
    compare.hidden = !oldPrice || oldPrice <= Number(price);
    compare.textContent = compare.hidden ? '' : money(oldPrice);
    quickDialog.querySelectorAll('[data-otti-option-group]').forEach(group => {
      const index = Number(group.dataset.ottiOptionGroup);
      const value = selectedOptions[index] || '';
      const output = group.querySelector('[data-otti-option-selected]');
      if (output) output.textContent = value;
      let hasUnavailable = false;
      group.querySelectorAll('[data-otti-option-value]').forEach(button => {
        const optionValue = button.dataset.ottiOptionValue;
        const isAvailable = candidatesFor(index,optionValue).length > 0;
        button.disabled = !isAvailable;
        button.classList.toggle('otti-is-unavailable',!isAvailable);
        button.setAttribute('aria-pressed',String(optionValue === value));
        button.setAttribute('aria-label',isAvailable ? optionValue : `${optionValue} — ${optionWords.sold}`);
        button.title = isAvailable ? optionValue : `${optionValue} — ${optionWords.sold}`;
        if (!isAvailable) hasUnavailable = true;
      });
      const guide = group.querySelector('[data-otti-stock-guide]');
      if (guide) guide.hidden = !hasUnavailable;
    });
  }
  async function showQuick(btn) {
    if (!quickDialog || !form) return;
    const url = safePath(btn.dataset.url || ''); if (!url) return;
    const thisRequest = ++quickRequestId;
    activeProduct = null; chosenVariant = null; selectedOptions = []; form.reset();
    quickDialog.querySelector('[data-otti-modal-title]').textContent = btn.dataset.title || '';
    quickDialog.querySelector('[data-otti-modal-type]').textContent = btn.dataset.type || 'OTTIOTTI';
    quickDialog.querySelector('[data-otti-modal-price]').textContent = quickDialog.dataset.loading || '';
    quickDialog.querySelector('[data-otti-modal-compare]').hidden = true;
    quickDialog.querySelector('[data-otti-modal-status]').textContent = '';
    quickDialog.querySelector('[data-otti-view-cart]').hidden = true;
    quickDialog.querySelector('[data-otti-modal-options]').replaceChildren();
    quickDialog.querySelector('[data-otti-modal-submit]').disabled = true;
    const detailsLink = quickDialog.querySelector('[data-otti-modal-details]');
    if (detailsLink) detailsLink.href = url;
    const fallbackImage = btn.closest('.otti-store-card')?.querySelector('.otti-store-card__photo')?.src || '';
    renderGallery(null,fallbackImage);
    if (!quickDialog.open) quickDialog.showModal();
    try {
      const response = await fetch(url.split('?')[0].replace(/\/$/,'') + '.js',{headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error(tr[3]);
      const product = await response.json();
      if (!quickDialog.open || thisRequest !== quickRequestId) return;
      activeProduct = product;
      quickDialog.querySelector('[data-otti-modal-title]').textContent = product.title || btn.dataset.title || '';
      renderGallery(product,fallbackImage);
      const typeLabel = quickDialog.querySelector('[data-otti-modal-type]');
      if (typeLabel) typeLabel.textContent = product.type || btn.dataset.type || 'OTTIOTTI';
      const available = (product.variants || []).find(v => v.available) || (product.variants || [])[0];
      selectedOptions = (available?.options || []).slice();
      const container = quickDialog.querySelector('[data-otti-modal-options]');
      (product.options || []).forEach((option,index) => {
        // Shopify product.js can return product.options as objects {name, position, values}.
        // Never interpolate the object: it displays as "[object Object]" in the storefront.
        const optionName = typeof option === 'string' ? option : (option && typeof option.name === 'string' ? option.name : '');
        const isDefaultOption = /^(?:Default Title|Title)$/i.test(optionName);
        if (product.variants.length === 1 && isDefaultOption) return;
        const group = document.createElement('fieldset'); group.className = 'otti-quick-dialog__option'; group.dataset.ottiOptionGroup = String(index);
        const legend = document.createElement('legend'); legend.className = 'otti-quick-dialog__label';
        legend.append(document.createTextNode(`${optionNameForDisplay(optionName)}: `));
        const selected = document.createElement('strong'); selected.dataset.ottiOptionSelected = ''; legend.appendChild(selected);
        const pills = document.createElement('div'); pills.className = 'otti-quick-dialog__choices';
        const values = [...new Set((product.variants || []).map(v => (v.options || [])[index]).filter(Boolean))];
        values.forEach(value => {
          const choice = document.createElement('button'); choice.type = 'button'; choice.className = 'otti-quick-dialog__choice';
          choice.dataset.ottiOptionValue = value;
          const name = document.createElement('span'); name.className = 'otti-quick-dialog__choice-name'; name.textContent = value;
          choice.appendChild(name);
          choice.addEventListener('click',() => chooseOption(index,value));
          pills.appendChild(choice);
        });
        const guide = document.createElement('small'); guide.className = 'otti-quick-dialog__stock-guide';
        guide.dataset.ottiStockGuide = ''; guide.textContent = `× ${optionWords.tip}`; guide.hidden = true;
        group.append(legend,pills,guide); container.appendChild(group);
      });
      updateVariant();
    } catch (error) {
      if (thisRequest !== quickRequestId || !quickDialog.open) return;
      quickDialog.querySelector('[data-otti-modal-price]').textContent = '';
      quickDialog.querySelector('[data-otti-modal-status]').textContent = error.message || tr[3];
    }
  }
  if (form) form.addEventListener('submit',async event => {
    event.preventDefault(); const submit = quickDialog.querySelector('[data-otti-modal-submit]');
    if (!chosenVariant?.available || submit.disabled) return;
    const count = Math.min(99,Math.max(1,parseInt(form.elements.quantity.value,10) || 1));
    submit.disabled = true; quickDialog.querySelector('[data-otti-modal-status]').textContent = quickDialog.dataset.loading || '';
    try {
      const sectionIds = [...new Set(all('cart-items-component[data-section-id]').map(el => el.dataset.sectionId).filter(Boolean))].slice(0,5);
      const payload = {items:[{id:Number(chosenVariant.id),quantity:count}]};
      if (sectionIds.length) { payload.sections = sectionIds; payload.sections_url = location.pathname; }
      const response = await fetch(`${shopRoot}cart/add.js`,{
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)
      });
      const result = await response.json(); if (!response.ok) throw new Error(result.description || tr[3]);
      const resCart = await fetch(`${shopRoot}cart.js`,{headers:{Accept:'application/json'}});
      if (resCart.ok) {
        const cart = await resCart.json();
        // Horizon cart-icon and product-form listen for exactly this event.
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'otti-quick-modal',data:{itemCount:cart.item_count,source:'otti-quick-modal',sections:result.sections || {}}}}));
      }
      quickDialog.querySelector('[data-otti-modal-status]').textContent = quickDialog.dataset.done || '';
      quickDialog.querySelector('[data-otti-view-cart]').hidden = false;
    } catch (err) { quickDialog.querySelector('[data-otti-modal-status]').textContent = err.message || tr[3]; }
    finally { submit.disabled = !chosenVariant?.available; }
  });
  document.addEventListener('click',event => {
    const favorite = event.target.closest('[data-otti-favorite]');
    if (favorite) { event.preventDefault(); event.stopPropagation(); toggleFavorite(favorite); return; }
    const open = event.target.closest('[data-otti-open-favorites]');
    if (open) { event.preventDefault(); favDialog?.showModal(); return; }
    const quick = event.target.closest('[data-otti-quick]');
    if (quick) { event.preventDefault(); showQuick(quick); }
  });
  all('[data-otti-filter-form]').forEach(filterForm => {
    filterForm.querySelector('[data-otti-sort]')?.addEventListener('change',() => filterForm.requestSubmit());
  });
  all('[data-otti-carousel-track]').forEach(track => {
    const section = track.closest('.otti-sale, .otti-products'); const bar = section?.querySelector('[data-otti-carousel-progress]');
    const step = () => (track.querySelector('.otti-store-card')?.getBoundingClientRect().width || 260) + (parseFloat(getComputedStyle(track).columnGap) || 0);
    section?.querySelector('[data-otti-carousel-prev]')?.addEventListener('click',() => track.scrollBy({left:-step(),behavior:'smooth'}));
    section?.querySelector('[data-otti-carousel-next]')?.addEventListener('click',() => track.scrollBy({left:step(),behavior:'smooth'}));
    const update = () => {
      if (!bar) return;
      const range = Math.max(0,track.scrollWidth-track.clientWidth); const width = Math.min(1,track.clientWidth / Math.max(1,track.scrollWidth));
      bar.style.width = `${width * 100}%`;
      const translate = range ? track.scrollLeft / range * (1-width) * (100/width) : 0;
      bar.style.transform = `translateX(${translate}%)`;
      section?.querySelector('[data-otti-carousel-prev]')?.toggleAttribute('disabled', track.scrollLeft <= 2);
      section?.querySelector('[data-otti-carousel-next]')?.toggleAttribute('disabled', range <= 2 || track.scrollLeft >= range - 2);
    };
    track.addEventListener('scroll',update,{passive:true}); window.addEventListener('resize',update,{passive:true}); update();
  });
  document.addEventListener('shopify:section:load',repaintFavorites);
  repaintFavorites();
})();
